export default __webpack_public_path__ + "static/media/truck-icon-green.53c7a431.svg";